import {
  GRAPHITE_COLOR,
  LG_COLOR,
  PLATINUM_COLOR,
} from 'containers/App/constants';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import { formContainerStyles, formGroupStyles } from '../style';

const LoginPageStyles = styled.div`
  .login-container {
    ${formContainerStyles}
  }

  .seperator {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 1rem 0;

    &-line {
      flex: auto;
      flex-basis: auto;
      border: none;
      outline: none;
      height: 2px;
      background: ${PLATINUM_COLOR};
    }

    &-text {
      font-family: inherit;
      font-size: 1rem;
      font-weight: 500;
      line-height: inherit;
      color: ${GRAPHITE_COLOR};
      margin: 0 1rem;
    }
  }

  .login-button-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    button {
      font-family: 'Montserrat', sans-serif !important;
      font-weight: 400 !important;
      margin: 0 10px;
      &:hover {
        background-color: ${LG_COLOR} !important;
        color: #fff !important;
        transition: 0.4s ease 0s !important;
      }
    }
  }
`;

export const UMSLoginFormStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  ${formGroupStyles}

  .form-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;

    .forgot-password {
      color: ${GRAPHITE_COLOR};
      cursor: pointer;
      font-size: 0.9rem;
    }
  }

  .request-access {
    cursor: pointer;
    text-decoration: none;
    color: rgb(48, 120, 144);
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const StyledModal = styled(Modal)`
  .modal-body {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  ${formGroupStyles}
`;

export default LoginPageStyles;
